import {
  API_ENDPOINT,
  useClientApiV1AccountsCredentialsQuery,
} from '../../resources/@types/accountSchema';

function useClientAccountCredentialsQuery(
  options?: Parameters<typeof useClientApiV1AccountsCredentialsQuery>[0]['options'],
) {
  return useClientApiV1AccountsCredentialsQuery({
    queryKey: [API_ENDPOINT.CLIENT_V1_ACCOUNTS_CREDENTIALS],
    url: API_ENDPOINT.CLIENT_V1_ACCOUNTS_CREDENTIALS,
    options,
  });
}

useClientAccountCredentialsQuery.queryKey = [API_ENDPOINT.CLIENT_V1_ACCOUNTS_CREDENTIALS];

export default useClientAccountCredentialsQuery;
